import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "lib-flexible"
import navMenu from '@/components/navMenu.vue'
import Header from '@/components/Header.vue'
import global from "@/global/global.js"

Vue.prototype.global = global
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.component('navMenu', navMenu);//侧边栏
Vue.component('Header', Header);//头部

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
